<template>
  <div class="carousel-wrapper">
    <Vue3Carousel
      :autoplay="5000"
      pause-autoplay-on-hover
      :items-to-show="1"
      wrap-around
      class="smirch-slider"
      snap-align="start"
      :breakpoints="breakpoints"
    >
      <Vue3Slide v-for="(item, index) in slides" :key="index">
        <template v-if="item">
          <div class="has-text-centered">
            <figure class="image">
              <ImageItem
                v-if="item.media"
                v-bind="item.media.image"
                :image-style="imageStyle"
                loading="eager"
              />
            </figure>
            <div
              v-if="item?.media?.caption"
              class="mt-4 is-size-small has-text-centered has-text-weight-semibold image-caption"
            >
              {{ item.media.caption }}
            </div>
            <Status :status="item.status" class="state" />
          </div>
        </template>
      </Vue3Slide>
      <template #addons>
        <Vue3Navigation />
      </template>
    </Vue3Carousel>
  </div>
</template>

<script setup lang="ts">
import type { ParagraphSmirchImageSliderFragment } from '#graphql-operations'

defineProps<{
  slides: ParagraphSmirchImageSliderFragment['slides']
}>()

defineBlokkli({
  bundle: 'smirch_slide',
})

const imageStyle = defineImageStyle({
  type: 'pictures',
  pictures: {
    xs: {
      aspectRatio: 730 / 486,
      width: 730,
      height: 486,
    },
  },
})

const breakpoints = {
  1440: {
    itemsToShow: 4,
  },
  990: {
    itemsToShow: 3,
  },
  768: {
    itemsToShow: 2,
  },
}
</script>

<style scoped lang="scss">
.carousel-wrapper {
  margin-left: toRem(95);
  margin-right: toRem(95);
}
.smirch-slider {
  --vc-nav-color: #{$grey-light};
  --vc-nav-color-hover: #{$grey-dark};
  --vc-nav-width: 50px;
  --vc-nav-height: 50px;
  $gap: 15px;

  width: calc(100% + 2 * #{$gap});
  margin: -$gap;

  .carousel__slide {
    min-width: 200px;
    padding: 0 $gap;
  }

  ::v-deep(.carousel__prev) {
    left: -80px;
    padding-bottom: 60px;
  }

  ::v-deep(.carousel__next) {
    right: -80px;
    padding-bottom: 60px;
  }
}

.state {
  margin-top: 1.5rem;
}
</style>
